/* 
eslint-disable no-mixed-operators
*/
import React from 'react';
import dlv from 'dlv';
import { applyPageMeta, applyScriptInjection } from '../../../../util';
import useConfig from '../../../../config';
import { useTranslation, scope, localizeObject } from '../../../../i18n';
import { useServices, useResult, inResults} from '../../../../service';
import { fillTemplate, fillTemplatedObject, valueFromTemplate } from '../../../../util/template';
import useScreens  from '../../';
import DynamicForm from './form';

const DynamicScreen = React.memo(
	({ children, descriptor, template, onComplete, previousScreenResults, componentConfig, onRequestScreen, onTemplate, activeTemplate, configScripts, ...props }) => {
		const { defaultTemplate }  = useConfig();
		const i18n = dlv(descriptor, 'i18n', {});
		const common_t = scope(useTranslation('common'));
		const t = scope(useTranslation(i18n.ns || 'common'), i18n.scope);
		const formDescriptor = dlv(descriptor, 'form', {});

		const [isInit, setIsInit] = React.useState(false);

		//Gets Services from descriptor:
		const servicesDesc = dlv(descriptor, 'service', [{id:'submit', proceedOnResult:formDescriptor.proceedOnResult}]);
		const services = Array.isArray(servicesDesc) ? servicesDesc : [servicesDesc];

		const screens = useScreens();
		const Template = screens[template] || (defaultTemplate && screens[defaultTemplate]) || screens.default || screens.Blank;

		const getService = name => (services.filter(serv => serv.id === name)[0] || {});
		const [ suspense, callService, result, errors, clearErrors, resultNotify ] = useServices(services, previousScreenResults, {scoped:t, common:common_t});

		const serviceRedirectOnResult = getService(result && result._service).redirectOnResult;
		const serviceProceedOnResult = getService(result && result._service).proceedOnResult;
		const serviceCallOnResult = getService(result && result._service).callOnResult;

		const handleCallService = (serviceArgs, serviceName) => callService(serviceArgs || {}, serviceName);
		const findTemplateValue = key => dlv(result, key) || inResults(previousScreenResults, key) || '';
		const dynamicProps = obj => fillTemplatedObject(localizeObject(t, obj), findTemplateValue);

		const info = dynamicProps(dlv(descriptor, 'info'));

		
		const handleResult = (r, go) => {
			if(serviceCallOnResult) {
				callService(r, serviceCallOnResult);
			} else if(serviceRedirectOnResult) { 
				const uri = fillTemplate(serviceRedirectOnResult, findTemplateValue);
				if(uri)window.location = uri;
			} else if (serviceProceedOnResult) {
				return onComplete(r, go);
			}
			return ;
		}

		useResult(result, handleResult, serviceProceedOnResult);
		

		React.useEffect(() => {
			if(onTemplate) {
				onTemplate({...props, Template, descriptor, info, t});
			}
		}, []); //eslint-disable-line react-hooks/exhaustive-deps

		React.useEffect(() => {
			if(activeTemplate !== Template)return;
			if(info && info.page) applyPageMeta(info.page);
			if(configScripts) applyScriptInjection(dynamicProps(configScripts));
			services.filter(service => valueFromTemplate(service.callOnMount, findTemplateValue)).forEach(service => callService(service.args || {}, service.id));
			setIsInit(true);
		}, [activeTemplate]); //eslint-disable-line react-hooks/exhaustive-deps


		return children || (
			<DynamicForm
				descriptor={formDescriptor}
				componentConfig={componentConfig}
				serviceDescriptors={services}
				onRequestScreen={onRequestScreen}
				onCallService={handleCallService}
				errors={errors}
				clearErrors={clearErrors}
				suspense={suspense}
				serviceResult={result}
				previousScreenResults={previousScreenResults}
				resultNotify={resultNotify}
				screenHasInit={isInit}
				t={t}
			/>
		);
	}
);

export default DynamicScreen;